<template>
	<mt-header class="header" title="限时抢购">
    <header-item v-if="isShowBack" slot="left" isBack v-on:onclick="leftClick"></header-item>
  </mt-header>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import { Header } from 'mint-ui'
import { HeaderItem } from '../../../components/common'

export default {
  name: "ProductListHeader",
  computed: {
    ...mapState({
      isOnline: state => state.auth.isOnline,
    }),
    ...mapGetters({
      isHasUnreadCount: 'isHasUnreadCount'
    }),
    isShowBack () {
			return true
    }
  },
  methods: {
			leftClick() {
        this.$router.go(-1)
			},
			goState() {
				this.$router.push('/search');
			}
	}
};
</script>

<style scoped lang='scss'>
  .header {
		@include header;
		background-color: #ed8b19;
		// border-bottom: 0.5px solid #E8EAED;
  }
</style>


// WEBPACK FOOTER //
// src/page/flashsale-list/child/ProductListHeader.vue